import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from '../../components/TemplateDashboard';
import AlertNotificaciones from '../../components/AlertNotificaciones/AlertNotificaciones';
import TutoriasGrupalesContent from './components/TutoriasGrupalesContent';

const TutoriasGrupales = () => {

    return (
        <>

            <TemplateDashboard>
                <AlertNotificaciones />
                <TutoriasGrupalesContent />
            </TemplateDashboard>

        </>
    )
};

export default TutoriasGrupales;